import { render, staticRenderFns } from "./EventsEvents.vue?vue&type=template&id=405b693d&scoped=true&"
import script from "./EventsEvents.vue?vue&type=script&lang=ts&"
export * from "./EventsEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405b693d",
  null
  
)

export default component.exports